import { container } from '../../../DataDomain';
import { CSRFTokenRequest, IBundleAndSaveInfoParams, IBundleAndSaveInfoResponse } from '../../../entity';
import { ISlpRepository } from '../../repositories/interfaces/iSlpRepository';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IBundleAndSaveInfoUseCase {
    execute(payload: IBundleAndSaveInfoParams, identityToken?: string, csrfToken?: CSRFTokenRequest): Promise<IBundleAndSaveInfoResponse>;
}

export class BundleAndSaveInfoUseCase implements IBundleAndSaveInfoUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get slpRepo(): ISlpRepository {
        return container.resolve<ISlpRepository>(DI.REPOSITORIES.ISlpRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(payload: IBundleAndSaveInfoParams, identityToken?: string, csrfToken?: CSRFTokenRequest): Promise<IBundleAndSaveInfoResponse> {
        return await this.slpRepo.bundleAndSaveInfo(payload, identityToken, csrfToken);
    }
}
